module.exports = __webpack_public_path__ + "/login_ui/img/it-bba84d4509037247777d1dc90af29e98.svg";